const {
	onControllerReady,
	fillWithDomElements,
	mediaQueryMin,
	trackGtm,
	trackGtm4,
} = require('util/functions');
const {
	default: { breakMediumBefore },
} = require('util/sass-variables');
const {
	outClickSubscribe,
	outClickUnSubscribe,
} = require('util/outClickSubscriber');
const { default: onWidthResize, stuttering } = require('util/onWidthResize');
const { bodyElement } = require('util/consts');

const CLASS_TITLE = 'sustainability-qa--title ';
const CLASS_VIDEO = 'basic-video';
const CLASS_CTA = 'sustainability-qa--cta';
const CLASS_OVERLAY = 'sustainability-qa--overlay';
const CLASS_CLOSE = 'sustainability-qa--overlay-close';
const CLASS_OVERLAY_CONTENT = 'sustainability-qa--overlay-content';

const CLASS_SCROLL = 'no-scroll';
const CLASS_ACTIVE = 'active';

const selectors = {
	title: CLASS_TITLE,
	video: CLASS_VIDEO,
	content: CLASS_OVERLAY_CONTENT,
	cta: CLASS_CTA,
	overlay: CLASS_OVERLAY,
	closeButton: CLASS_CLOSE,
};

module.exports = {
	async init() {
		fillWithDomElements(this, selectors);
		if (this.video) this.video = await onControllerReady(this.video);
		this.initStyles();
		this.initEvents();
		this.closeButton.setAttribute('aria-label', bodyElement.dataset.closeLabel);
		onWidthResize(this.onResize.bind(this), stuttering.DEBOUNCE, 100);
	},
	initEvents() {
		this.cta.addEventListener('click', this.openOverlay.bind(this));
		this.closeButton.addEventListener('click', this.closeOverlay.bind(this));
	},
	openOverlay(e) {
		e.stopPropagation();
		outClickSubscribe(this.overlay, this.closeOverlay.bind(this));
		this.overlay.style.height = this.getHeight();
		this.overlay.setAttribute('tabindex', 0);
		this.overlay.classList.add(CLASS_ACTIVE);
		if (!mediaQueryMin(breakMediumBefore)) {
			this.toggleScroll(true);
		}
		this.trackOpening();
	},
	closeOverlay() {
		outClickUnSubscribe(this.overlay);
		this.overlay.style.height = 0;
		this.overlay.setAttribute('tabindex', -1);
		this.overlay.classList.remove(CLASS_ACTIVE);
		this.toggleScroll(false);

		if (this.video?.childVideo?.__controller?.video)
			this.video.childVideo.__controller.video.pause();
	},
	trackOpening() {
		if (this.alreadyTracked) return;
		trackGtm({
			eventCategory: 'cta',
			eventAction: 'qa widget',
			eventLabel: this.title.textContent,
		});
		trackGtm4({
			event: 'GA4_event_c_cta',
			widget_name: 'V3-Sustainability QA block',
			widget_title: this.title.textContent,
			link_text: this.cta.innerHTML,
			link_url: 'Opens pop up',
			button_type: '',
		});
		this.alreadyTracked = true;
	},
	initStyles() {
		if (mediaQueryMin(breakMediumBefore)) {
			//Set top so the overlay always opens from the top of the clicked qa block
			this.overlay.style.top = this.root.offsetTop + 'px';
			this.overlay.style.position = 'absolute';
			this.content.style.height = this.root.dataset.overlayHeight + 'px';
		} else {
			this.overlay.style.top = 0;
			this.overlay.style.position = 'fixed';
			this.content.style.height = '100%';
		}
	},
	getHeight() {
		let height = 0;
		if (mediaQueryMin(breakMediumBefore)) {
			const overlayHeight = this.checkHeight();
			height = overlayHeight
				? overlayHeight.height + 'px'
				: parseInt(this.root.dataset.overlayHeight) + 100 + 'px';
		} else {
			height = '100%';
		}
		return height;
	},
	//Check to see if the overlay will go over the document
	checkHeight() {
		const rect = this.root.getBoundingClientRect();
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const scrollHeight = document.documentElement.scrollHeight;
		if (
			this.root.dataset.overlayHeight >
			scrollHeight - (scrollTop + rect.top)
		) {
			return { height: scrollHeight - (scrollTop + rect.top) - 20 };
		} else {
			return null;
		}
	},
	toggleScroll(open) {
		document.body.classList.toggle(CLASS_SCROLL, open);
	},
	onResize() {
		if (this.overlay.classList.contains(CLASS_ACTIVE)) {
			this.closeOverlay();
		}
		this.initStyles();
	},
};
